import React from 'react';

const Component = props => {
	return (
		<>
			<div className='my-[50px]'>
				<h2 className='text-[30px] md:text-[25px] font-normal mb-[30px] text-[#282e3f]'>
					Présentation personnelle
				</h2>
				<p className='text-[#666] text-[16px] leading-[28px] mb-[20px]'>
					Après avoir obtenu son bachelier en droit à l'Université de Namur, Maître HARTOUANE Sadia a
					poursuivi son cursus à l'Université catholique de Louvain, où elle a obtenu en 2024 son master en
					droit.
				</p>
				<p className='text-[#666] text-[16px] leading-[28px] mb-[20px]'>
					Avant d'entamer son stage au Barreau de Charleroi en septembre 2025, elle a acquis une première
					expérience professionnelle au sein d'un bureau de courtage en assurances. Cette expérience a
					renforcé son intérêt pour le droit des assurances et la responsabilité civile.
				</p>
				<p className='text-[#666] text-[16px] leading-[28px] mb-[20px]'>
					Au sein du cabinet GAVA-Lex, elle traite du droit des assurances, de la responsabilité civile et de
					la circulation routière, du droit de la famille, du droit de la jeunesse ainsi que du droit pénal,
					et s’investit dans la défense des intérêts de ses clients, en privilégiant l'écoute et la
					compréhension des situations afin de proposer un accompagnement adapté.
				</p>
			</div>
		</>
	);
};

export default Component;
